export class Logger {
    log(message) {
        console.log(message);
    }
}

const logger = new Logger();
export default logger;

